import React from "react";

import { Results as ResultsComponent } from "heat-next";

import { useSessionDetailsContext } from "@/context/session-details/session-details";

import "perfect-scrollbar/css/perfect-scrollbar.css";

import { ComponentWrapper } from "@/pages/shared/shared.styles";

import ContentLoader from "@/components/content-loader/content-loader";
import EmptyState from "@/components/empty-state/empty-state";
import { EmptyStateType } from "@/components/empty-state/empty-state.types";

interface ResultsProps {
    subDimensionData?: any;
    showQuestionIcons?: boolean;
    showSubTitle?: boolean;
    filterIcon?: React.ReactElement;
}

const Results: React.FC<ResultsProps> = ({
    subDimensionData,
    showQuestionIcons,
    showSubTitle = true,
    filterIcon,
}) => {
    const { resultsData, isFetchingResults, isErrorResults } = useSessionDetailsContext();

    if (isFetchingResults) {
        return <ContentLoader height="23.8125rem" />;
    }

    if (isErrorResults && !isFetchingResults) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="error-state:title"
                    description="error-state:description"
                    emptyStateType={EmptyStateType.Error}
                    minHeight="20.8125rem"
                />
            </ComponentWrapper>
        );
    }

    const isEmptyState =
        !isErrorResults &&
        !subDimensionData &&
        (resultsData === null || resultsData?.dataset?.length === 0);

    if (isEmptyState) {
        return (
            <ComponentWrapper>
                <EmptyState
                    title="session-details:results:empty-state:title"
                    emptyStateType={EmptyStateType.Charts}
                    minHeight="20.8125rem"
                />
            </ComponentWrapper>
        );
    }

    return (
        <ResultsComponent
            data={subDimensionData ?? resultsData}
            showQuestionIcons={showQuestionIcons}
            showSubTitle={showSubTitle}
            filterIcon={filterIcon}
        />
    );
};

export default Results;
